<!--single mode-->
<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="'default'">
    <ui-select-search
      [selectId]="nzId"
      [disabled]="disabled"
      [value]="inputValue!"
      [showInput]="showSearch"
      [mirrorSync]="false"
      [autofocus]="autofocus"
      [focusTrigger]="open"
      (isComposingChange)="isComposingChange($event)"
      (valueChange)="onInputValueChange($event)"></ui-select-search>
    <ui-select-item
      *ngIf="isShowSingleLabel"
      [deletable]="false"
      [disabled]="false"
      [removeIcon]="removeIcon"
      [label]="listOfTopItem[0].nzLabel"
      [contentTemplateOutlet]="customTemplate"
      [contentTemplateOutletContext]="listOfTopItem[0]"></ui-select-item>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <!--multiple or tags mode-->
    <ui-select-item
      *ngFor="let item of listOfSlicedItem; trackBy: trackValue"
      [removeIcon]="removeIcon"
      [label]="item.nzLabel"
      [disabled]="item.nzDisabled || disabled"
      [contentTemplateOutlet]="item.contentTemplateOutlet"
      [deletable]="true"
      [contentTemplateOutletContext]="item.contentTemplateOutletContext"
      (delete)="onDeleteItem(item.contentTemplateOutletContext)"></ui-select-item>
    <ui-select-search
      [selectId]="nzId"
      [disabled]="disabled"
      [value]="inputValue!"
      [autofocus]="autofocus"
      [showInput]="true"
      [mirrorSync]="true"
      [focusTrigger]="open"
      (isComposingChange)="isComposingChange($event)"
      (valueChange)="onInputValueChange($event)"></ui-select-search>
  </ng-container>
</ng-container>
<ui-select-placeholder *ngIf="isShowPlaceholder" [placeholder]="placeHolder"></ui-select-placeholder>
